/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2019-05-31 14:47:27
 * @LastEditors: yy
 * @LastEditTime: 2020-08-17 15:11:09
 */
import baseChart from './customBaseChart'

export default (opt = {}) => {
  let { list, color } = opt;
  return Object.assign(baseChart(opt), {
    series: [{
      type: 'wordCloud',
      shape: 'circle',
      // maskImage: img,

      left: 'center',
      top: 'center',
      width: '70%',
      height: '80%',
      right: null,
      bottom: null,

      // Text size range which the value in data will be mapped to.
      // Default to have minimum 12px and maximum 60px size.

      sizeRange: [12, 80],

      // Text rotation range and step in degree. Text will be rotated randomly in range [-90, 90] by rotationStep 45

      rotationRange: [-90, 90],
      rotationStep: 45,

      // size of the grid in pixels for marking the availability of the canvas
      // the larger the grid size, the bigger the gap between words.

      gridSize: opt.fontSpace || 20,

      // set to true to allow word being draw partly outside of the canvas.
      // Allow word bigger than the size of the canvas to be drawn
      drawOutOfBound: false,

      // Global text style
      textStyle: {
        normal: {
          fontFamily: 'AlibabaPuHuiTi',
          // fontStyle: 'italic',
          // fontWeight: 'bold',
          // Color can be a callback function or a color string
          color: color || function () {
            // Random color
            return 'rgb(' + [
              Math.round(Math.random() * 160),
              Math.round(Math.random() * 160),
              Math.round(Math.random() * 160)
            ].join(',') + ')';
          }
        },
        emphasis: {
          shadowBlur: 10,
          shadowColor: '#333'
        }
      },

      // Data is an array. Each array item must have name and value property.
      data: (list || []).filter(item => item.value !== undefined && item.name !== undefined).map(item => {
        item.value = parseInt(item.value)
        return item
      })
    }]
  })
}


// WEBPACK FOOTER //
// src/chart/wordcloud.js